
import useStore from "@/composables/useStore";
import { defineComponent, watch } from "vue";
import { ADD_TO_CART_BUTTON, ADD_TO_CART_BUTTONV2 } from "@/config";

export default defineComponent({
    name: "AddToCartButton",
    setup() {
        const getOriginalButton: () => HTMLButtonElement | null = () =>
            document.querySelector(ADD_TO_CART_BUTTON) ||
            document.querySelector(ADD_TO_CART_BUTTONV2);

        const {
            computed: { selectedDiamond }
        } = useStore();

        async function handleButtonClick(event: Event) {
            event.preventDefault();

            if (selectedDiamond.value !== null) {
                const diamondVariantId = selectedDiamond.value.shopifyVariantId;

                const form = document.querySelector<HTMLFormElement>(
                    //@ts-expect-error Global not defined
                    `form[action="${window.Shopify.routes.root}cart/add"]`
                );

                if (!form) {
                    window.alert(
                        "Beim hinzufügen des Artikels ist etwas schief gegeangen, bitte wenden Sie sich and unseren Support."
                    );
                    return;
                }
                const initialFormData = Object.fromEntries(
                    new FormData(form).entries()
                );

                const baseProductId = initialFormData?.["id"];

                try {
                    const response = await fetch(
                        // @ts-expect-error
                        window.Shopify.routes.root + "cart/add.js",
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                items: [
                                    {
                                        id: baseProductId,
                                        quantity: 1,
                                        properties: {
                                            // eslint-disable-next-line
                                            _dyr_id: `dyr-${diamondVariantId}`
                                        }
                                    },
                                    {
                                        id: diamondVariantId,
                                        quantity: 1,
                                        properties: {
                                            // eslint-disable-next-line
                                            _dyr_id: `dyr-${diamondVariantId}`
                                        }
                                    }
                                ],
                                sections: "site-header,cart",
                                // eslint-disable-next-line
                                sections_url: window.location.pathname
                            })
                        }
                    ).then(response => {
                        if (!response.ok) {
                            throw response;
                        }
                        return response;
                    });

                    (document.querySelector("shopify-cart") as HTMLElement & {
                        onCartUpdate(response: unknown, id: unknown): unknown;
                    })?.onCartUpdate(response, baseProductId);
                } catch (error) {
                    console.error(error);
                }
            }
        }

        function cloneButton() {
            const wrapper =
                document.querySelector(".product-form--atc") ||
                document.querySelector("product-form");

            const originalButton = getOriginalButton();

            if (originalButton !== null && wrapper !== null) {
                const newButton: HTMLButtonElement = originalButton.cloneNode(
                    true
                ) as HTMLButtonElement;
                newButton.disabled = false;
                newButton.addEventListener("click", handleButtonClick);
                newButton.classList.add("disabled");
                newButton.style.display = "none";

                wrapper.appendChild(newButton);

                watch(selectedDiamond, () => {
                    if (selectedDiamond.value !== null) {
                        newButton.classList.remove("disabled");
                        newButton.style.display = "block";
                    } else {
                        newButton.classList.add("disabled");
                        newButton.style.display = "none";
                    }
                });
            } else {
                console.log(
                    "[Diamond Configurator] Did not find add to cart button and / or wrapper"
                );
            }
        }

        cloneButton();
    }
});
